import { commitMutation, graphql } from "react-relay";
import environment from "../AuthEnv";
import { GC_AUTH_TOKEN, GC_USER_ID, GRAPHQL_PATH } from "../constants";
import { ConnectionHandler } from "relay-runtime";

const mutation = graphql`
	mutation AddBookmarkMutation($input: AddBookmarkInput!) {
		addBookmark(input: $input) {
			bookmarkEdge {
				cursor
				node {
					id
					is_bookmarked
				}
			}
			viewer {
				id
			}
		}
	}
`;

function sharedUpdater(store, bookmarkEdge, postIdString) {
	// console.log("Post Id: " + postIdString);
	const postProxy = store.get(postIdString)
	// console.log(postProxy);
	// console.log("User: " + localStorage.getItem(GC_USER_ID));
	const connection = ConnectionHandler.getConnection(
		postProxy,
		"Bookmark_simpleBookmark"
	);

	if (connection) {
		ConnectionHandler.insertEdgeBefore(connection, bookmarkEdge);
	}
}

let nextClientMutationId = 0;
export default (postIdString, postId, callback) => {
	const clientMutationId = nextClientMutationId.toString();
	const variables = {
		input: {
			postId: postId
		}
	};

	let linkedRecord = null;

	commitMutation(environment, {
		mutation,
		// optimisticResponse,
		variables,

		updater(store) {
			const payload = store.getRootField("addBookmark");
			if (payload != null) {
				linkedRecord = payload.getLinkedRecord("bookmarkEdge");
				sharedUpdater(store, linkedRecord, postIdString);
			}

			// console.log(payload.getValue('id'));
		},
		optimisticUpdater(store) {
			if (linkedRecord) {
				const id = `client:addBookmark:Bookmark:${clientMutationId}`;
				const newBookmark = store.create(id, "Bookmark");
				newBookmark.setValue(id, "id");
				const bookmarkEdge = store.create(
					`client:addBookmark:bookmarkEdge:${clientMutationId}`,
					"bookmarkEdge"
				);
				bookmarkEdge.setLinkedRecord(newBookmark, "node");
				sharedUpdater(store, bookmarkEdge, postIdString);
			}
		},
		onCompleted: (response, errors) => {
			if (response.addBookmark != null) {
				callback();
			} else {
				// console.log("Unable to create new Bookmark!");
			}
		},
		onError: err => console.error(err)
	});
};
